import { render } from "./ReturnedToSupplierTable.vue?vue&type=template&id=11632d98&scoped=true"
import script from "./ReturnedToSupplierTable.vue?vue&type=script&lang=js"
export * from "./ReturnedToSupplierTable.vue?vue&type=script&lang=js"

import "./ReturnedToSupplierTable.vue?vue&type=style&index=0&id=11632d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11632d98"]])

export default __exports__